(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;

  document.documentElement.classList.add('ps-motion');

  const STAGGER_CONTAINERS = [
    '.product-grid',
    '.bars-grid',
    '.reassure-stats',
    '.ps-collection__grid',
    '.ps-related__grid',
    '.ps-press__logos',
    '.review-grid',
    '.ps-careers__track',
    '.ps-careers__roles-grid',
  ];

  const REVEAL_TARGETS = [
    '.section-head',
    '.ps-showcase__header',
    '.ps-showcase__panel',
    '.reassure-copy',
    '.story-media',
    '.story-copy',
    '.ps-press__header',
    '.ps-press__quotes',
    '.newsletter',
    '.ps-collection__header',
    '.ps-collection__toolbar',
    '.ps-buy',
    '.ps-gallery',
    '.locator',
    '.faq-item',
    '.ps-franchise__hero',
    '.ps-careers__banner-copy',
    '.ps-careers__story-copy',
    '.ps-careers__section-head',
    '.ps-careers__story-media',
    '.ps-contact__hero',
    '.ps-story-page__hero',
  ];

  const HERO_SEQUENCE = [
    '#hero .hero-eyebrow',
    '#hero h1',
    '#hero .hero-sub',
    '#hero .hero-cta',
    '#hero .hero-pack',
  ];

  const staggerParentSelector = STAGGER_CONTAINERS.join(',');

  const markReveal = (el, variant = 'up', delay = 0) => {
    if (!el || el.classList.contains('ps-reveal')) return;
    el.classList.add('ps-reveal', `ps-reveal--${variant}`);
    if (delay > 0) el.style.setProperty('--ps-reveal-delay', `${delay}ms`);
  };

  const revealNow = (el, delay = 0) => {
    window.setTimeout(() => el.classList.add('is-revealed'), delay);
  };

  STAGGER_CONTAINERS.forEach((selector) => {
    document.querySelectorAll(selector).forEach((container) => {
      [...container.children].forEach((child, index) => {
        markReveal(child, 'up', index * 85);
      });
    });
  });

  REVEAL_TARGETS.forEach((selector) => {
    document.querySelectorAll(selector).forEach((el) => {
      if (el.closest(staggerParentSelector)) return;
      const variant = el.classList.contains('story-media') || el.classList.contains('ps-careers__story-media') ? 'left'
        : el.classList.contains('story-copy') || el.classList.contains('ps-careers__story-copy') ? 'right'
        : el.classList.contains('ps-gallery') ? 'scale'
        : 'up';
      markReveal(el, variant);
    });
  });

  const heroSlide = document.querySelector('#hero .ps-hero__slide.is-active') || document.querySelector('#hero');
  if (heroSlide) {
    HERO_SEQUENCE.forEach((selector, index) => {
      const scoped = selector.replace('#hero ', '');
      const el = heroSlide.querySelector(scoped) || document.querySelector(selector);
      if (!el) return;
      const variant = selector.includes('hero-pack') ? 'scale' : 'up';
      markReveal(el, variant, index * 95);
      revealNow(el, 80 + index * 95);
    });
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-revealed');
      observer.unobserve(entry.target);
    });
  }, {
    threshold: 0.14,
    rootMargin: '0px 0px -48px 0px',
  });

  document.querySelectorAll('.ps-reveal:not(.is-revealed)').forEach((el) => observer.observe(el));

  // Showcase panel — swap copy when the active product changes
  const showcase = document.querySelector('[data-ps-showcase]');
  if (showcase) {
    const panel = showcase.querySelector('.ps-showcase__panel');
    const animatePanel = () => {
      panel?.querySelectorAll('.ps-showcase__title, .ps-showcase__desc, .ps-showcase__kicker').forEach((el) => {
        el.classList.remove('ps-text-swap');
        void el.offsetWidth;
        el.classList.add('ps-text-swap');
      });
    };

    let panelTimer;
    showcase.addEventListener('click', (event) => {
      if (event.target.closest('[data-ps-showcase-slide], [data-ps-showcase-prev], [data-ps-showcase-next], .carousel-dot')) {
        clearTimeout(panelTimer);
        panelTimer = window.setTimeout(animatePanel, 120);
      }
    });
    showcase.querySelector('[data-ps-showcase-track]')?.addEventListener('scroll', () => {
      clearTimeout(panelTimer);
      panelTimer = window.setTimeout(animatePanel, 180);
    }, { passive: true });
  }

  // Quick-add success micro-bounce
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('.quick-add, .ps-cart-drawer__upsell-add, .ps-related-card__atc');
    if (!btn || btn.disabled) return;
    btn.classList.add('ps-pop-in');
    window.setTimeout(() => btn.classList.remove('ps-pop-in'), 520);
  });
})();
